import { BrowserRouter, Routes, Route, Link, Navigate, Outlet } from 'react-router-dom';
import Home from './pages/Home';
import Play from './pages/Play';
import Search from './pages/Search';
import Login from "./pages/Login";
import CreateTournament from './pages/CreateTournament';
import ChatTest from './pages/ChatTest';
import PushNotification from './pages/PushNotification';
import PendingTournaments from './pages/PendingTournaments';
import Dashboard from './pages/Dashboard';
import Health from './pages/Health';
import AllTournaments from './pages/AllTournaments';
import TournamentDetails from './pages/TournamentDetails';
import TournamentDetail from './pages/TournamentDetail';

import './Global.css';

// Korumalı Rota Bileşeni
const ProtectedRoutes = () => {
  const token = localStorage.getItem('JWTTOKEN');
  
  // Token yoksa logine yönlendir, "replace" ile geçmişi temizle ki geri tuşuyla dönülemesin
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  // Token varsa alt rotaları (Outlet) render et
  return <Outlet />;
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* Navigasyon Kısmı */}

        {/* Sayfa İçeriklerinin Değiştiği Alan */}
        <Routes>
          {/* Herkese Açık Rota */}
          <Route path="/login" element={<Login />} />

          {/* Sadece Giriş Yapmış Kullanıcılara Açık Rotalar */}
          <Route element={<ProtectedRoutes />}>
            <Route path="/" element={<Home />} />
            <Route path="/play" element={<Play />} />
            <Route path="/search" element={<Search />} />
            <Route path="/create" element={<CreateTournament />} />
            <Route path="/chat" element={<ChatTest />} />
            <Route path="/push-notification" element={<PushNotification />} />
            <Route path="/pending-tournaments" element={<PendingTournaments />} />
            <Route path="/tournament-detail/:id" element={<TournamentDetail />} />
            <Route path="/dashboard/" element={<Dashboard />} />
            <Route path="/health/" element={<Health />} />
            <Route path="/all/" element={<AllTournaments />} />
            <Route path="/detail/:id" element={<TournamentDetails />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;